export const state = {
  list: [],
  pagination: null,
  unreadCount: 0,
  startDate: null,
  hackathonDirections: [{
    name_ru: "Технологии в ИИ", 
    name_oz: "AI dagi texnologiyalar", 
    name_en: "Technologies in AI", 
    key: 'ai_tech'
  },{
    name_ru: "Агротехнологии", 
    name_oz: "Qishloq xo'jaligi texnologiyalari", 
    name_en: "Agricultural technologies", 
    key: 'agrtech'
  },{
    name_ru: "Цифровая медицина", 
    name_oz: "Raqamli tibbiyot", 
    name_en: "Digital medicine", 
    key: 'digitmed'
  },{
    name_ru: "Финансовые технологии", 
    name_oz: "Moliyaviy texnologiyalar", 
    name_en: "Financial technologies", 
    key: 'fintech'
  },{
    name_ru: "Умные города", 
    name_oz: "Aqlli shaharlar", 
    name_en: "Smart cities", 
    key: 'smartcity'
  }]
}
